import React from 'react';


const Step2b = (props) => {
    return (
        <div id="step-2b" className="question-step">
            <div className="step-title_container">

                <div className="col-11 col-md-10">
                    <h2 className="question-title">Few more of the usual things.</h2>
                    <hr className="question-title_line"/>
                    <p className="question-text">We will use this information to review your credit score and history so
                        that we can provide you with real, accurate loan options. Don’t worry, this will not lower your
                        credit score at all! </p>
                </div>

                    <div className="step-2_form clearfix">
                        {
                            props.questions.map((q, i) => {
                                if (i >= props.start && i <= props.end) {
                                    return props.renderQuestion(q, i)
                                }

                            })
                        }
                    </div>

            </div>
        </div>
    )
}

export default Step2b;
